/* eslint-disable @fullscript/cross-reference */
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import { Button, Column } from "@aviary";
import type { ButtonProps } from "@aviary";
import {
  GET_PRODUCT,
  ProductSearchQueryDefaultOptions,
} from "@clinic/shared/data/queries/ProductSearchQuery";
import { PrefetchButton } from "@patient/components/PrefetchButton";
import type { Brand } from "@shared/components/CatalogSearch/CatalogSearch";
import { useProductSearchVariables } from "@shared/hooks";
import { FontAwesomeIcon } from "@shared/react-fontawesome";

import * as styles from "./BrandsListItem.styles";

interface Props extends ButtonProps {
  brand: Brand;
  isActive?: boolean;
  to?: ButtonProps["to"];
}

const BrandsListItem = ({ brand, isActive, ...rest }: Props) => {
  const { name, logo } = brand;
  const productSearchVariables = useProductSearchVariables();

  const renderListItemChildren = () => (
    <>
      <span css={styles.logoName}>{name}</span>
      {isActive && <FontAwesomeIcon css={styles.icon} icon={faCheckCircle} />}
    </>
  );

  const renderListItem = () => {
    if (rest.to) {
      return (
        <PrefetchButton
          css={[styles.brandListItem(logo), isActive && styles.active]}
          isSize="large"
          isColor="system"
          to={rest.to}
          query={GET_PRODUCT}
          variables={{
            ...productSearchVariables,
            ...ProductSearchQueryDefaultOptions.variables,
            filters: {
              ...ProductSearchQueryDefaultOptions.variables.filters,
              ...productSearchVariables.filters,
              brandIds: [brand.id],
            },
          }}
        >
          {renderListItemChildren()}
        </PrefetchButton>
      );
    }

    return (
      <Button
        css={[styles.brandListItem(logo), isActive && styles.active]}
        isSize="large"
        isColor="system"
        {...rest}
      >
        {renderListItemChildren()}
      </Button>
    );
  };

  return <Column columnWidth={3}>{renderListItem()}</Column>;
};

export { BrandsListItem };
